import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(2, 0),
    borderLeft: '4px solid #eee',
    padding: theme.spacing(1, 0, 1, 1.5),
    '& > p:first-child': {
      marginTop: theme.spacing(0)
    },
    '& > p:last-child': {
      marginBottom: theme.spacing(0)
    }
  }
}));

const Blockquote = ({ children, className }) => {
  const classes = useStyles();
  return (
    <blockquote className={clsx(classes.wrapper, className)}>
      {children}
    </blockquote>
  );
};

Blockquote.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Blockquote;
